import React from 'react'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'

const lmTheme = createMuiTheme({
	palette: {
		primary: {
			main: '#458209', //Profilgrön
			contrastText: 'white',
			textColor: 'white',
			background: 'white'
		},
		secondary: {
			main: '#C64D07', //Samma färg som i loggan (nästan profilröd)
		},
	},
	zIndex: {
		onTopOfMap: 500
	}
})

export default ({ children }) => (
	<MuiThemeProvider theme={lmTheme}>
		{children}
	</MuiThemeProvider>
)



// WEBPACK FOOTER //
// ./src/components/LmThemeProvider.js